/**
 * Deleo delivery tracking status codes
 * These are the status codes returned from the Deleo API
 */
export enum DeliveryTrackingStatus {
  Delivered = 'D06',
  CustomsCleared = 'I04',
  InCustoms = 'I03',
  ArrivedDestination = 'I02',
  Departed = 'I01',
  InvoiceIssued = 'I00',
}

export const DELIVERED_STATUS = DeliveryTrackingStatus.Delivered;

/**
 * PARXL delivery tracking status codes
 * These are the status strings returned from the PARXL API
 */
export enum ParxlTrackingStatus {
  // Booking statuses
  Booked = 'Booked',
  Cancelled = 'Cancelled',
  Expired = 'Expired',
  BookingReceived = 'Booking received',
  BookingRejected = 'Booking rejected',

  // Pickup & Processing
  PickedUp = 'Picked up',
  ReceivedAtExportHub = 'Received at parxl export hub',
  ProcessingAtExportHub = 'Processing at parxl export hub',

  // Transit
  ReadyToTransfer = 'Ready to transfer to airline',
  ReceivedAtAirlineTerminal = 'Received at airline terminal',
  DepartedFromOrigin = 'Departed from origin airport',
  InTransit = 'In transit',

  // Arrival
  ArrivedAtDestinationAirport = 'Arrived at destination airport',
  ArrivedAtCustomsFacility = 'Arrived at destination customs facility',
  EnrouteToSortingHub = 'Enroute to destination sorting hub',
  ArrivedAtSortingHub = 'Arrived and processed at sorting hub',
  ArrivedAndProcessingAtSortingHub = 'Arrived and processing at sorting hub',

  // Customs
  HandedOverForCustoms = 'Handed over for customs clearance',
  CustomCleared = 'Custom cleared at destination',

  // Delivery
  OutForDelivery = 'Out for delivery',
  Delivered = 'Delivered',
  AwaitingCollection = 'Awaiting collection',

  // Delivery Issues
  UnsuccessfulDelivery = 'Unsuccessful delivery',
  FinalUnsuccessfulDelivery = 'Final unsuccessful delivery',
  PossibleDelay = 'Possible delay from last mile',

  // Exceptions
  Disposed = 'Disposed',
  DamagedAtDestination = 'Damaged at destination',
  Damaged = 'Damaged',
  Lost = 'Lost',

  // Modifications
  Relabelled = 'Relabelled',
  Repackaged = 'Repackaged',
  Translated = 'Translated',
  AddressChange = 'Address change',
}

export const PARXL_DELIVERED_STATUS = ParxlTrackingStatus.Delivered;
